export default {
  name: 'GraphicRiver',
  abbreviation: 'GR',
  domain: 'graphicriver.net',
  google_analytics_id: 'UA-11834194-6',
  google_remarketing_label: 'hJ8ZCL2AugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. brochure template',
  experimentsLoadingCover: true,
  features: {
    /**
     * @description Enables new routing strategy
     * @author Pawel Galazka / Traffic team
     * @expires
     */
    'routes:new': true,
    /**
     * @description Is true, we collapse the tags filter for all category pages unless it's a bottom level category (no children)

     * @author Geoff Evason
     * @expires Never
     */
    'collapse-tags-unless-bottom-category': true,
    /**
     * @description Enable cookiebot
     * @author Luke Robins
     * @expires
     */
    cookiebot: true,
    /**
     * @description Enables new category page design
     * @author Pawel Galazka
     * @expires when category pages experiment is over for all markets
     */
    categoryRedesign: true
  },
  surveys: {
    search: {
      url: 'https://forms.gle/UnWvvPSKAgM5rw8d8',
      text:
        'Please complete our 2 minute survey to help improve your experience',
      linkText: 'Click here',
      minSearchCountToShow: 2
    },
    category: {
      url: 'https://forms.gle/5bhpPa1hZdXNpv9D8',
      text:
        'Please complete our 2 minute survey to help improve your experience',
      linkText: 'Click here',
      minSearchCountToShow: 2
    }
  }
}
